export default __webpack_public_path__ + "static/media/Justworks.1594b021.svg";